import React, { Component } from "react";
import contentify from "../../content/Contentify";
import Store from "./../../content/Store";
import style from "../../assets/css/modules/cover/cover.css";
import ShadowedContainer from "../shared/containers/ShadowedContainer";
import Article from "../shared/Article";
import HelpSection from "../shared/HelpSection";
import PromoContainer from "../shared/containers/PromoContainer";
import { Paths } from "../../constants/UrlConstants";
import MskSection from "../shared/MskSection";
import InfoBox from "../shared/InfoBox";
import FileDownloadList from "../../components/download/FileDownloadList";
import { connect } from "react-redux";
import { getCoverDocuments } from "../../actions/cover/CoverActions";
import { mapStateToProps as mapStateToCoverDocuments } from "../../helpers/cover/CoverDocumentHelper";
import CoverAddAPlanLink from "./CoverAddAPlanLink";
import PromoImageCard from "../shared/PromoImageCard";
import { getLayout } from "../../layout/Layout";
import { Layouts } from "../../constants/Constants";

export function mapDispatchToProps(dispatch) {
  return {
    getCoverDocuments: (membershipNumber) =>
      dispatch(getCoverDocuments(membershipNumber))
  };
}

export class CoverDocuments extends Component {
  constructor(props) {
    super(props);

    if (
      this.props.membershipNumber &&
      (this.props.MembershipStatement === undefined ||
        (this.props.MembershipStatement === null && !this.props.isDependant))
    ) {
      this.props.getCoverDocuments(this.props.membershipNumber);
    }
  }

  static content = {
    ...Store.Cover,
    ...Store.CoverDocuments,
    ...Store.Home.Cards
  };
  render() {
    let helpSetContent = this.props.content.HelpSection.HelpSetForHarpa;

    if (this.props.isSMEModular || this.props.isSME) {
      helpSetContent = this.props.content.HelpSection.HelpSetForSMEModular;
    } else if (this.props.isLargeCorporate) {
      helpSetContent = this.props.content.HelpSection.HelpSetForLargeCorporate;
    } else if (this.props.HideCoverDetails) {
      helpSetContent = this.props.content.HelpSection.HelpSetForCrest;
    }

    return (
      <React.Fragment>
        <ShadowedContainer>
          <div className="row">
            <div className="col-12">
              <div className={style.articleDescription}>
                <Article
                  header={this.props.content.CoverDocumentsTitle}
                  body={this.props.content.CoverDocumentsDescription}
                />
              </div>
              {(this.props.isSME || this.props.isSMEModular) && this.props.shouldShowGuide? (
                <div id="underwriting" className={style.underwriting}>
                  <Article
                    header={this.props.content.PrivateHealthCareTitle}
                    body={this.props.content.PrivateHealthCareDescription}
                  />
                </div>
              ) : null}
              {this.props.isSME || this.props.isSMEModular ? (
                <div id="underwriting" className={style.underwriting}>
                  <Article
                    header={this.props.content.UnderwritingTitle}
                    body={this.props.content.UnderwritingDescription}
                  />
                </div>
              ) : null}
              {this.props.membershipStatementMissing ? (
                <InfoBox
                  iconClass={"icon-functional-help"}
                  children={this.props.content.MembershipStatementMissing}
                  className="my-4"
                />
              ) : null}

              {this.props.isDependant ? (
                <InfoBox
                  iconClass={"icon-functional-help"}
                  children={
                    this.props.content.DependantMembershipStatementMessage
                  }
                  className="my-4"
                />
              ) : null}
              {this.props.documentList && this.props.documentList.length > 0 ? (
                <FileDownloadList files={this.props.documentList} />
              ) : null}
            </div>
          </div>
          {this.props.showCoverAddAPlanLink && <CoverAddAPlanLink />}
          <div className={style.helpSection}>
            <HelpSection
              HeadingLinkText={this.props.content.HelpSection.HeadingLinkText}
              HeadingLinkTo={this.props.content.HelpSection.HeadingLinkTo}
              MoreHelpLinkText={this.props.content.HelpSection.MoreHelpLinkText}
              MoreHelpLinkTo={this.props.content.HelpSection.MoreHelpLinkTo}
              HelpSet={helpSetContent}
            />
          </div>
        </ShadowedContainer>
        <PromoContainer>
          {!this.props.isLapsed && (this.props.isAgeAbove18 ?
          (<MskSection accessPage={Paths.Cover} UniqueKey="mskBanner" />):
          this.props.isCrestData?
            (<PromoImageCard
              ImgSrc={Store.Home.Cards.AskMedExpert.IconSrc}
              ImgSrcMobile={Store.Home.Cards.AskMedExpert.IconSrcMobile}
              Heading={Store.Home.Cards.AskMedExpert.Heading}
              Description={Store.Home.Cards.AskMedExpert.Description}
              LinkText={Store.Home.Cards.AskMedExpert.LinkText}
              LinkTo={Store.Home.Cards.AskMedExpert.LinkTo}
              LeftImage
            />):(
            <PromoImageCard
            ImgSrc={Store.PromoCards.AccessHealthSupportSrc.IconSrc}
            ImgSrcMobile={
              Store.PromoCards.AccessHealthSupportSrc.IconSrcMobile
            }
            Heading={Store.PromoCards.AccessHealthSupportSrc.Heading}
            Description={
              Store.PromoCards.AccessHealthSupportSrc.Description
            }
            LinkText={Store.PromoCards.AccessHealthSupportSrc.LinkText}
            LinkTo={getLayout()===Layouts.HOL ?  Store.PromoCards.AccessHealthSupportSrc.LinkToHOL : Store.PromoCards.AccessHealthSupportSrc.LinkTo}
            LeftImage
          />
          ))}
        </PromoContainer>
      </React.Fragment>
    );
  }
}

export default connect(
  mapStateToCoverDocuments,
  mapDispatchToProps
)(contentify(CoverDocuments));
